export const environment = {
    production: true,
    tenant: 'aircon',
    loginToken: 'e8eec1f0-3c55-480a-8b3b-e32856c40db2',
    apiServerUrl: `/api-server`,
    firebase: {
        apiKey: "AIzaSyDrrO8cfSfohpjsOkry4oTq2CXJl6s8D_M",
        authDomain: "angie-iot-prod-d57ba.firebaseapp.com",
        projectId: "angie-iot-prod-d57ba",
        storageBucket: "angie-iot-prod-d57ba.firebasestorage.app",
        messagingSenderId: "512013221922",
        appId: "1:512013221922:web:dd1d0d8cf4ad760714ca7b",
        measurementId: "G-RV4P9V4ZJN"
    },
    mapTilesAddress: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    sentry: {
        enabled: true,
        environment: 'production',
    }
};
